const lockSvg = `<svg width="65" height="65" viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M48.25 23.3612H45.5833V18.2818C45.5833 11.2723 39.61 5.58337 32.25 5.58337C24.89 5.58337 18.9167 11.2723 18.9167 18.2818V23.3612H16.25C13.3167 23.3612 10.9167 25.6469 10.9167 28.4405V53.8373C10.9167 56.631 13.3167 58.9167 16.25 58.9167H48.25C51.1833 58.9167 53.5833 56.631 53.5833 53.8373V28.4405C53.5833 25.6469 51.1833 23.3612 48.25 23.3612ZM32.25 46.2183C29.3167 46.2183 26.9167 43.9326 26.9167 41.1389C26.9167 38.3453 29.3167 36.0596 32.25 36.0596C35.1833 36.0596 37.5833 38.3453 37.5833 41.1389C37.5833 43.9326 35.1833 46.2183 32.25 46.2183ZM40.5167 23.3612H23.9833V18.2818C23.9833 13.9389 27.69 10.4088 32.25 10.4088C36.81 10.4088 40.5167 13.9389 40.5167 18.2818V23.3612Z" fill="#FFFAEE"/></svg>`;

const getSignInLinkTitleFromUserLocale = () =>
  window.location.href.includes('/fr/')
    ? 'Connectez-vous pour accéder au contenu vidéo.'
    : 'Sign-in to access our video content.';

export default function init(
  containerToLock: HTMLElement,
  insertionNode: HTMLElement,
  redirectionLink = ''
) {
  const sandboxIframeWrapper = containerToLock;
  sandboxIframeWrapper.style.filter = 'blur(4px)';

  const lockIcon = document.createElement('img');
  lockIcon.classList.add('oc-locked-content__lock-icon');
  lockIcon.src = `data:image/svg+xml;utf8,${encodeURIComponent(lockSvg)}`;
  lockIcon.alt = '';

  if (redirectionLink) {
    const loginLinkWrapper = document.createElement('a');
    loginLinkWrapper.classList.add('oc-locked-content');
    loginLinkWrapper.href = redirectionLink;
    loginLinkWrapper.appendChild(sandboxIframeWrapper);
    loginLinkWrapper.title = getSignInLinkTitleFromUserLocale();

    sandboxIframeWrapper.style.pointerEvents = 'none';
    loginLinkWrapper.appendChild(lockIcon);

    insertionNode.parentNode?.insertBefore(loginLinkWrapper, insertionNode);
  } else {
    const lockWrapper = document.createElement('div');
    lockWrapper.classList.add('oc-locked-content');
    lockWrapper.appendChild(sandboxIframeWrapper);

    sandboxIframeWrapper.style.pointerEvents = 'none';
    lockWrapper.appendChild(lockIcon);

    insertionNode.parentNode?.insertBefore(lockWrapper, insertionNode);
  }
}
